import { useContext } from "react";
import appContext from "../../context/appContext";

//design component
import { Avatar } from "@mui/material";
import {
  UilTachometerFastAlt,
  UilArrowGrowth,
  UilCreditCard,
  UilBell,
  UilUser,
  UilSignOutAlt,
  UilWindSun,
  UilBed,
  UilSchedule,
} from "@iconscout/react-unicons";

//style
import "../../styles/components/sidebar.scss";
//imgs
import img from "../../assets/logoo.svg";
import img1 from "../../assets/logoFa.png";

import SideBarItem from "./SideBarItem";

// Dark mode
import React, { useEffect, useState } from "react";
import { UilWindMoon } from "@iconscout/react-unicons";

const SideBar = () => {
  const { setAppTheme } = useContext(appContext);

  // Dark mode
  const [theme, setTheme] = useState("light-theme");
  const switchTheme = () => {
    // console.log(theme_selected)
    if (theme == "dark-theme") {
      setTheme("light-theme");
      localStorage.setItem("dark-toast-bg-color", "#fff");
      localStorage.setItem("dark-toast-font-color", "#132c4b");
      localStorage.setItem("hrm-theme", "light-theme");
      setAppTheme("light");
    } else {
      setTheme("dark-theme");
      localStorage.setItem("dark-toast-bg-color", "#132c4b");
      localStorage.setItem("dark-toast-font-color", "#fff");
      localStorage.setItem("hrm-theme", "dark-theme");
      setAppTheme("dark");
    }
  };

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  const { collapse, userLogout } = useContext(appContext);
  return (
    <>
      <div
        className={`sideBar py-3  d-lg-block d-none ${
          collapse ? "sidebarOpen" : "sidebarClose"
        }`}
      >
        <div className="inner  d-flex flex-column h-100 justify-content-between">
          <div className="">
            <div className={`  py-1  text-decoration-none`}>
              <div className=" d-flex text-nowrap  ">
                <div className={`p-2 `}>
                  <div className="image">
                    <img className="h-100 w-100" src={img} alt="" />
                  </div>
                </div>
                <div className={`title  d-grid align-items-center `}>
                  <div className="image__text">
                    <img className="w-100 top-20" src={img1} alt="" />
                  </div>
                </div>
              </div>
            </div>
            <SideBarItem
              link={"/work"}
              title={"ثبت حضور"}
              icon={<UilTachometerFastAlt />}
            />
            <SideBarItem
              link={"/statistics"}
              title={"مشاهده آمار"}
              icon={<UilArrowGrowth />}
            />
            <SideBarItem
              link={"/financial"}
              title={"حساب مالی "}
              icon={<UilCreditCard />}
            />
            <SideBarItem
              link={"/weekly"}
              title={"برنامه هفتگی"}
              icon={<UilSchedule />}
            />
            <SideBarItem link={"/vacation"} title={"مرخصی"} icon={<UilBed />} />
          </div>
          <div>
            <div
              className={`sideBarItem d-flex text-nowrap switch-mode`}
              style={{ pointerEvents: "none" }}
              onClick={() => switchTheme()}
            >
              <div className={`sideBarItem__icon p-2 dark-mode-icon`}>
                <UilWindMoon />
              </div>

              <div className={`sideBarItem__icon p-2 light-mode-icon`}>
                <UilWindSun />
              </div>

              <div
                className={`title  d-grid align-items-center ${
                  collapse ? "showTitle" : "hideTitle"
                }`}
              >
                حالت شب & روز
              </div>
            </div>

            <div
              className={`sideBarItem d-flex text-nowrap  `}
              style={{ pointerEvents: "none" }}
            >
              <div className={`sideBarItem__icon p-2 `}>
                <UilBell />
              </div>
              <div
                className={`title  d-grid align-items-center ${
                  collapse ? "showTitle" : "hideTitle"
                }`}
              >
                اعلان ها
              </div>
            </div>

            <div
              className={`sideBarItem d-flex text-nowrap  `}
              style={{ pointerEvents: "none" }}
            >
              <div className={`sideBarItem__icon p-2 `}>
                <UilUser />
              </div>
              <div
                className={`title  d-grid align-items-center ${
                  collapse ? "showTitle" : "hideTitle"
                }`}
              >
                حساب کاربری
              </div>
            </div>

            <div onClick={() => userLogout()}>
              <div className={`  sideBarItem d-flex text-nowrap  `}>
                <div className={`sideBarItem__icon p-2 `}>
                  <UilSignOutAlt />
                </div>
                <div
                  className={`title  d-grid align-items-center ${
                    collapse ? "showTitle" : "hideTitle"
                  }`}
                >
                  خروج
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
